module.exports = __webpack_public_path__ + "static/media/mn12.62f8c2fd.jpeg";